import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { ClubInfoCards } from './ClubInfoCards';
import { ContactDirectory } from './ContactDirectory';
import { QuickLinks } from './QuickLinks';
export function ContactPage() {
  return <PageLayout data-id="element-854">
      <HeaderBanner data-id="element-855" />
      <ClubInfoCards data-id="element-856" />
      <ContactDirectory data-id="element-857" />
      <QuickLinks data-id="element-858" />
    </PageLayout>;
}